import { createIcon } from '../createIcon';
import { ReactComponent as IconCoin } from '../svg/coin.svg';

export default createIcon(IconCoin);
